/**
 * `/v1/ops/email-templates/*` transport (#1911).
 *
 * Five fixed rows, editable and nothing else — no create, no delete. The key
 * set is closed on purpose: `balance_alert.critical` is what an unattended
 * cron reaches for at the moment nobody is watching, and a template that can
 * be removed is a sender that can be left with nothing to say.
 */
import type {
  EmailTemplate,
  EmailTemplateKey,
  EmailTemplateTestSendRequest,
  EmailTemplateTestSendResponse,
  ListEmailTemplatesResponse,
  UpdateEmailTemplateRequest,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

const BASE = '/v1/ops/email-templates';

function templatePath(key: EmailTemplateKey, suffix = ''): string {
  return `${BASE}/${encodeURIComponent(key)}${suffix}`;
}

export async function listEmailTemplates(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<readonly EmailTemplate[]> {
  const response = await opsApiRequest<ListEmailTemplatesResponse>(BASE, { signal }, fetchImpl);
  return response.templates;
}

export async function updateEmailTemplate(
  key: EmailTemplateKey,
  body: UpdateEmailTemplateRequest,
  fetchImpl: typeof fetch,
): Promise<EmailTemplate> {
  return opsApiRequest<EmailTemplate>(templatePath(key), { method: 'PUT', body }, fetchImpl);
}

export async function testSendEmailTemplate(
  key: EmailTemplateKey,
  body: EmailTemplateTestSendRequest,
  fetchImpl: typeof fetch,
): Promise<EmailTemplateTestSendResponse> {
  return opsApiRequest<EmailTemplateTestSendResponse>(
    templatePath(key, '/test-send'),
    { method: 'POST', body },
    fetchImpl,
  );
}
